import { createSelector } from "@reduxjs/toolkit";
import {
  DRIVER_SORT_TYPES,
  ROUTE_SORT_TYPES,
  SECTION_SORT_TYPES,
  SHIFT_MANAGERS_SORT_TYPES,
  SORT_ORDERS,
} from "../../consts/sorters";
import {
  routesSorters,
  driversSorters,
  sectionsSorters,
  shiftManagersSorters,
} from "../../utils/sorters";
export const sortOrderSelector = (state) => state.sorters.sortOrder;
export const sortTypeSelector = (state) => state.sorters.sortType;
export const routesSorterSelector = createSelector(
  sortOrderSelector,
  sortTypeSelector,
  (sortOrder, sortType) => {
    const sorter =
      routesSorters[sortType] || routesSorters[ROUTE_SORT_TYPES.ROUTE_NUMBER];
    if (sortOrder === SORT_ORDERS.DESC) return (a, b) => sorter(a, b);
    else return (a, b) => sorter(b, a);
  }
);
export const driversSorterSelector = createSelector(
  sortOrderSelector,
  sortTypeSelector,
  (sortOrder, sortType) => {
    const sorter =
      driversSorters[sortType] ||
      driversSorters[DRIVER_SORT_TYPES.DRIVER_NUMBER];
    if (sortOrder === SORT_ORDERS.DESC) return (a, b) => sorter(a, b);
    else return (a, b) => sorter(b, a);
  }
);
export const depotRoutesSorterSelector = createSelector(
  sortOrderSelector,
  (sortOrder) => {
    const sorter = routesSorters[ROUTE_SORT_TYPES.ROUTE_NUMBER];
    if (sortOrder === SORT_ORDERS.DESC) return (a, b) => sorter(a, b);
    else return (a, b) => sorter(b, a);
  }
);
export const sectionsSorterSelector = createSelector(
  sortOrderSelector,
  sortTypeSelector,
  (sortOrder, sortType) => {
    const sorter =
      sectionsSorters[sortType] ||
      sectionsSorters[SECTION_SORT_TYPES.SECTION_NAME];
    if (sortOrder === SORT_ORDERS.DESC) return (a, b) => sorter(a, b);
    else return (a, b) => sorter(b, a);
  }
);

export const shiftManagersSorterSelector = createSelector(
  sortOrderSelector,
  sortTypeSelector,
  (sortOrder, sortType) => {
    const sorter =
      shiftManagersSorters[sortType] ||
      shiftManagersSorters[SHIFT_MANAGERS_SORT_TYPES.SHIFT_MANAGER_CODE];
    if (sortOrder === SORT_ORDERS.DESC) return (a, b) => sorter(a, b);
    else return (a, b) => sorter(b, a);
  }
);
